document.addEventListener('DOMContentLoaded', function() {
  // --- 1. DAĻA: Elementu parādīšanās animācija (Fade-in) ---
  const fadeElements = document.querySelectorAll('.cnc-fade-in');

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15 // Elements parādās, kad tas ir 15% redzams ekrānā
  };

  const observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Animē tikai vienu reizi
      }
    });
  }, observerOptions);

  fadeElements.forEach(element => {
    observer.observe(element);
  });

  // --- 2. DAĻA: Interaktīvais fons melnajam headerim ---
  const header = document.querySelector('.cnc-header');
  
  if (header) {
    header.addEventListener('mousemove', function(e) {
      // Iegūstam elementa izmērus un pozīciju
      const rect = header.getBoundingClientRect();
      
      // Aprēķinām peles X un Y pozīciju attiecībā pret headeri
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      // Padodam šīs vērtības uz CSS kā mainīgos
      header.style.setProperty('--mouse-x', `${x}px`);
      header.style.setProperty('--mouse-y', `${y}px`);
    });
  }
});
// --- 3. DAĻA: Nejauši mirgojošie punkti (Random Twinkling Dots) ---
  const gridSize = 30; // Jāsakrīt ar CSS background-size (30px)
  const dotCount = 15; // Cik punkti vienlaicīgi var mirgot (vari palielināt vai samazināt)

  if (header) {
    for (let i = 0; i < dotCount; i++) {
      createRandomDot();
    }

    function createRandomDot() {
      const dot = document.createElement('div');
      dot.classList.add('cnc-random-dot');
      
      // Nejaušs animācijas ilgums katram punktam (no 1.5 līdz 4 sekundēm)
      const duration = Math.random() * 2.5 + 1.5; 
      dot.style.animationDuration = `${duration}s`;
      
      // Novietojam punktu
      placeDot(dot);
      header.appendChild(dot);

      // Kad punktiņš nodziest, tas nomaina pozīciju un sāk mirgot atkal
      dot.addEventListener('animationend', () => {
        dot.style.animation = 'none'; // Atiestata animāciju
        void dot.offsetWidth; // Piespiež pārlūku reģistrēt izmaiņas
        placeDot(dot); // Iedod jaunu lokāciju
        dot.style.animation = `twinkle ${Math.random() * 2.5 + 1.5}s ease-in-out forwards`;
      });
    }

    function placeDot(dot) {
      const rect = header.getBoundingClientRect();
      const cols = Math.floor(rect.width / gridSize);
      const rows = Math.floor(rect.height / gridSize);
      
      // Aprēķina precīzu koordinātu, lai punktiņš trāpītu tieši uz 30x30 sieta krustpunkta
      const x = Math.floor(Math.random() * cols) * gridSize + (gridSize / 2);
      const y = Math.floor(Math.random() * rows) * gridSize + (gridSize / 2);
      
      dot.style.left = `${x}px`;
      dot.style.top = `${y}px`;
    }
  }